import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AppService, AppSettingService } from '../app.service';

@Component({
	selector: 'app-action-more',
	templateUrl: `./action-more.component.html`,
	styleUrls: ['./territory-card.scss'],
	standalone: false
})
export class ActionMoreComponent implements OnInit {
	@Input() fontAwesomeIconClass: string = "";	
	@Input() actionLabel: string = "";

	constructor(
	) { }

	ngOnInit(): void {		
	}
}
